
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import { getLevelOptions } from "../../template/common";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifCompose: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
    // 处理数据
    if (this.data.report) {
      if (
        this.data.report["左手脉象信息输出"] &&
        this.data.report["左手脉象信息输出"]["脉名"] == "其它脉"
      ) {
        this.data.report["左手脉象信息输出"]["脉名"] = "大脉";
      }
      if (
        this.data.report["右手脉象信息输出"] &&
        this.data.report["右手脉象信息输出"]["脉名"] == "其它脉"
      ) {
        this.data.report["右手脉象信息输出"]["脉名"] = "大脉";
      }
    }
  }
  private data: any = {};
  private colors: any = [
    "#08C664",
    "#ECA12C",
    "#F60D0D",
    "#F541F3",
    "#19DDDB",
    "#94E51A",
    "#0CCDA9",
    "#DFD111",
    "#A911DF",
    "#6D65EE",
  ];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private editorChange(e: any) {
    this.data.report.suggest = e;
    this.change();
  }
  private change() {
    this.$emit("changeData", this.data);
  }
  private getOption(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  private open(url: any) {
    window.open(url);
  }
  private mounted() {}
}
